module.exports = __webpack_public_path__ + "static/media/sliders-h-square.8bbfb2bc.svg";